import { render, staticRenderFns } from "./RejectCollectingEmailPopup.vue?vue&type=template&id=d824b914&scoped=true&"
import script from "./RejectCollectingEmailPopup.vue?vue&type=script&lang=js&"
export * from "./RejectCollectingEmailPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d824b914",
  null
  
)

export default component.exports